import React from "react";

import NoDataOverlay from "./NoDataOverlay";

export const NoExperimentDataOverlay = () => {
  return (
    <NoDataOverlay
      message1={"No Data Yet"}
      message2={
        "Check back later, it may take up to two hours after experiment launch for data to appear."
      }
    />
  );
};

export const NoExperimentOverlay = () => {
  return (
    <NoDataOverlay
      message1={"No Data Yet"}
      message2={"Check back when you have started an experiment!"}
    />
  );
};

export const NoExperimentSubscriptionDataOverlay = () => {
  return (
    <NoDataOverlay
      message1={"No Data Yet"}
      message2={
        "No subscription orders have been placed in this experiment yet"
      }
    />
  );
};
